import React, { Component } from 'react'
import {MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavbarToggler, MDBCollapse, MDBContainer, MDBDropdown, 
  MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBRow, MDBCol } from 'mdbreact'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faExternalLink } from '@fortawesome/pro-duotone-svg-icons'
import { Link } from 'gatsby'

class NavBarPage extends Component {
  state = {
    collapsed: false,
  }

  handleTogglerClick = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    })
  }

  componentDidMount() {
    const str = window.location.pathname.substr(
      1,
      window.location.pathname.length - 1
    )
    const len = str.indexOf('/')
    this.setState({
      parentNav: len < 0 ? str : str.substr(0, len),
    })
  }

  render() {
    const overlay = (
      <div
        id="sidenav-overlay"
        style={{ backgroundColor: 'transparent' }}
        onClick={this.handleTogglerClick}
      />
    )

    const isActive = ({ isCurrent }) => {
      return isCurrent ? { className: 'nav-link active' } : {}
    }

    const isPartiallyActive = ({ isPartiallyCurrent }) => {
      return isPartiallyCurrent ? { className: 'nav-link active' } : {}
    }

    return (
      <div>
        <MDBNavbar
          color="top-nav-collapse"
          dark
          expand="lg"
          fixed="top"
          scrolling
          transparent
        >
          <MDBContainer>
            <MDBNavbarBrand>
              <Link to="/">
                <img
                  src="/detec-logo.svg"
                  alt="Company logo"
                  title="DETEC"
                  height="42"
                />
              </Link>
            </MDBNavbarBrand>
            <MDBNavbarToggler
              aria-label="Mobile Navigation Button"
              onClick={this.handleTogglerClick}
            />
            <MDBCollapse isOpen={this.state.collapsed} navbar>
              <MDBNavbarNav right>
                <MDBNavItem>
                <Link to="/produkte/" getProps={isPartiallyActive} className="nav-link">
                   Produkte
                  </Link>
                </MDBNavItem>

                <MDBNavItem>
                  <MDBDropdown>
                    <MDBDropdownToggle nav caret className={ this.state.parentNav === 'serviceangebot' ? 'active' : '' } >
                      <span className="mr-1">Serviceangebot</span>
                    </MDBDropdownToggle>
                    <MDBDropdownMenu className="dropdown-ug">
                      <MDBDropdownItem href="/serviceangebot/">
                        Serviceangebot
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/serviceangebot/schulung/">
                        - Schulung
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/serviceangebot/technical-support/">
                        - Support
                      </MDBDropdownItem>
                      <MDBDropdownItem href="https://support.detec.com/" target="_blank">
                        - Kundenportal
                        <FontAwesomeIcon
                          icon={faExternalLink}
                          className="ml-2"
                        />
                      </MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBNavItem>


                <MDBNavItem>
                <Link to="/partner/" getProps={isPartiallyActive} className="nav-link">
                    Partner
                  </Link>
                </MDBNavItem>

                <MDBNavItem>
                  <MDBDropdown>
                    <MDBDropdownToggle nav caret 
                      className={ (this.state.parentNav === 'ueber' || 
                      this.state.parentNav === 'karriere' || 
                      this.state.parentNav === 'kontakt' || 
                      this.state.parentNav === 'veranstaltungen' || 
                      this.state.parentNav === 'news' || 
                      this.state.parentNav === 'informationsmaterial' ||                    
                      this.state.parentNav === 'leadership') 
                      ? 'active' : '' } >
                      <span className="mr-1">Unternehmen</span>
                    </MDBDropdownToggle>
                    <MDBDropdownMenu className="dropdown-ug">
                      <MDBDropdownItem href="/kontakt/">
                        Kontakt
                      </MDBDropdownItem>
                      <hr className="nav" />
                      <MDBDropdownItem href="/veranstaltungen/">
                        Veranstaltungen
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/news/">
                        Presse
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/informationsmaterial/">
                        Informationsmaterial
                      </MDBDropdownItem>
                      <hr className="nav" />
                      <MDBDropdownItem href="/ueber/">
                        Über
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/karriere/">
                        Karriere
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/leadership/">
                        Leadership
                      </MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBNavItem>

                <MDBNavItem>
                  <a href="/search/" className="nav-link d-none d-lg-block" aria-label="Search">
                    <FontAwesomeIcon icon={faSearch} />
                  </a>
                  <a href="/search/" className="nav-link d-lg-none d-sm-block" aria-label="Search">
                    Search
                  </a>
                </MDBNavItem>

              </MDBNavbarNav>
            </MDBCollapse>
          </MDBContainer>
        </MDBNavbar>
        {this.state.collapsed && overlay}
      </div>
    )
  }
}

export default NavBarPage